import React from 'react';
import { Box, Container, Grid, Typography, Link as MuiLink } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Fiber Telekom
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              Altyapı beklemeden, fiber hızında interneti evinize getiriyoruz. Tak-çalıştır modemlerimizle özgürlüğün tadını çıkarın.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Kurumsal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink href="#" color="inherit" underline="hover">Hakkımızda</MuiLink>
              <MuiLink href="#" color="inherit" underline="hover">İletişim</MuiLink>
              <MuiLink href="#" color="inherit" underline="hover">Kariyer</MuiLink>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Destek
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink href="#" color="inherit" underline="hover">Sıkça Sorulan Sorular</MuiLink>
              <MuiLink href="#" color="inherit" underline="hover">Gizlilik Politikası</MuiLink>
              <MuiLink href="#" color="inherit" underline="hover">Kullanım Koşulları</MuiLink>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 5, pt: 3, borderTop: '1px solid rgba(255, 255, 255, 0.2)', textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
            &copy; {new Date().getFullYear()} Fiber Telekom. Tüm hakları saklıdır.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
